import { FC } from 'react';
import { Button, DefaultContentComponent, Popup } from '@silverfort/sf-components';

interface Props {
    open: boolean;
    handleConfirm: VoidFunction;
    handleClose: VoidFunction;
}

const FooterComponent: FC<Pick<Props, 'handleConfirm'>> = ({ handleConfirm }) => {
    return (
        <div className="flex flex-row flex-1 justify-end">
            <Button text="Close" onClick={handleConfirm} />
        </div>
    );
};

const EntraIdConfigureAccessPopup: FC<Props> = ({ open, handleConfirm, handleClose }) => {
    return (
        <Popup
            open={open}
            title="Configure access"
            ContentComponent={DefaultContentComponent}
            ContentComponentProps={{
                text: 'Configure a conditional access rule in EntraID to require MFA, using Microsoft Authenticator as the security method.'
            }}
            FooterComponent={FooterComponent}
            FooterComponentProps={{ handleConfirm }}
            onClose={handleClose}
            popupClassName="w-[360px] h-[240px]"
        />
    );
};

export default EntraIdConfigureAccessPopup;
